import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import BusinessPartnerTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-type/business-partner-type.entity";
import { ICreateBusinessPartnerType } from "./interfaces/create-business-partner-type.interface";
import { IUpdateBusinessPartnerType } from "./interfaces/update-business-partner-type.interface";
const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "business-partner-type";

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerTypeService extends AbstractService<
  BusinessPartnerTypeAttributes,
  ICreateBusinessPartnerType,
  IUpdateBusinessPartnerType
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<BusinessPartnerTypeAttributes> & { status?: number[] }
  ): Observable<IPaginationResult<BusinessPartnerTypeAttributes>> {
    const query = buildQuery<BusinessPartnerTypeAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("code", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      andAllWhere("statusId", Ops.in(...options?.status ?? [])),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<BusinessPartnerTypeAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(type?): Observable<IRequestResult<BusinessPartnerTypeAttributes[]>> {
    const query = buildQuery<BusinessPartnerTypeAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      type ? andAllWhere("isEmployee", type == '1' ? true : false) : noop(),
      //select(["code", "name", "isEmployee"]),
      orderBy("code", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<BusinessPartnerTypeAttributes[]>>(API_URL);
  }
}
